<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mfsao6/tc-custom/9781250077660.jpg?1737767663937" alt="This image is the cover for the book Schadenfreude, A Love Story"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Schadenfreude, A Love Story
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>A wild and wonderful ride” from a comic memoirist “who writes brilliantly about Germany and Germans . . . and being young and insane. . . . just read it, ok?” (Dave Barry, Pulitzer Prize–winning, <i>New York Times</i>–bestselling author of <i>Best. State. Ever</i>).</b><br/><br/>You know that feeling you get watching the elevator doors slam shut just before your toxic coworker can step in? There’s a word for this mix of malice and joy, and the Germans invented it. It’s Schadenfreude, deriving pleasure from others’ misfortune. Misfortune happens to be a specialty of Rebecca Schuman—and this is great news for the Germans. For Rebecca adores the Vaterland with a single-minded passion.<br/><br/>Let’s just say the affection isn’t mutual.<br/><br/>Schadenfreude is the story of a teenage Jewish intellectual who falls in love—with a boy (who breaks her heart), a language (that’s nearly impossible to master), a culture (that’s nihilistic, but punctual), and a landscape (that’s breathtaking when there’s not a wall in the way). Rebecca is a misunderstood 90’s teenager with a passion for Pearl Jam and Ethan Hawke circa <i>Reality Bites</i>, until two men walk into her high school Civics class: Dylan Gellner, with deep brown eyes and an even deeper soul, and Franz Kafka, hitching a ride in Dylan’s backpack. These two men are the axe to the frozen sea that is Rebecca’s spirit, and what flows forth is a passion for all things German.<br/><br/>At once a snapshot of a young woman finding herself, and a country starting to stitch itself back together after nearly a century of war, <i>Schadenfreude, A Love Story</i> is a hilarious and heartfelt memoir proving that sometimes the truest loves play hard to get.<br/><br/>“Spit-out-your-schnitzel funny.” —Pamela Druckerman, <i>New York Times</i>–bestselling author of <i>Bringing Up Bébé</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Schuman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Flatiron Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?784698d1